export default "/institutions/c6.svg";